export default __webpack_public_path__ + "c66465590541129e82d3d6f725c5658b.woff";